import React from "react";
import dayjs from "dayjs";
import { PRESETS, getRangeForPreset } from "../utils/dateRanges";

const PRESET_OPTIONS = [
  { value: PRESETS.TWO_MONTHS_PRIOR, label: "2 Months Ago" },
  { value: PRESETS.PREVIOUS_MONTH, label: "Previous Month" },
  { value: PRESETS.THIS_MONTH, label: "This Month" },
  { value: PRESETS.LAST_7_DAYS, label: "Last 7 Days" },
  { value: PRESETS.PREVIOUS_DAY, label: "Previous Day" },
  { value: PRESETS.CUSTOM, label: "Custom" }
];

const fieldClass =
  "border border-slate-300 rounded-lg px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-brand-light focus:border-brand-dark transition-shadow";
const labelClass = "block text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1.5";

// onChange(preset, range, shouldSearch) — shouldSearch is true whenever the
// resulting range is complete and ready to fetch immediately (no Apply button).
const DateFilter = ({ preset, startDate, endDate, onChange }) => {
  const today = dayjs().format("YYYY-MM-DD");

  const handlePresetClick = (value) => {
    if (value === PRESETS.CUSTOM) {
      onChange(value, { startDate, endDate }, false);
      return;
    }

    onChange(value, getRangeForPreset(value), true);
  };

  const handleCustomDateChange = (nextRange) => {
    onChange(PRESETS.CUSTOM, nextRange, Boolean(nextRange.startDate && nextRange.endDate));
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 mb-6">
      <label className={labelClass}>Date Range</label>

      <div className="flex flex-wrap items-end gap-4">
        <div className="flex flex-wrap gap-2">
          {PRESET_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => handlePresetClick(option.value)}
              className={`px-3.5 py-2 rounded-lg text-sm font-medium transition-colors ${
                preset === option.value
                  ? "bg-brand-dark text-white"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>

        {preset === PRESETS.CUSTOM && (
          <>
            <div>
              <label className={labelClass}>Start Date</label>
              <input
                type="date"
                className={fieldClass}
                value={startDate}
                max={today}
                onChange={(e) => handleCustomDateChange({ startDate: e.target.value, endDate })}
              />
            </div>

            <div>
              <label className={labelClass}>End Date</label>
              <input
                type="date"
                className={fieldClass}
                value={endDate}
                max={today}
                onChange={(e) => handleCustomDateChange({ startDate, endDate: e.target.value })}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DateFilter;
